import React, {useCallback, useContext} from 'react';
import {EditorContext, useEditorState} from "@tiptap/react";
import {Menu, MenuButton, MenuItem, MenuItems, Transition} from "@headlessui/react";
import {FaChevronDown, FaListOl, FaListUl} from "react-icons/fa";

const icons = {
    bulletList: <FaListUl className="rich-text-button-icon" />,
    orderedList: <FaListOl className="rich-text-button-icon" />
}

const listTitle = {
    bulletList: "Lista com marcador",
    orderedList: "Lista numerada"
}

const isListActive = (editor, type) => {
    if (!editor) return false

    switch (type) {
        case "bulletList":
            return editor.isActive("bulletList")
        case "orderedList":
            return editor.isActive("orderedList")
        default:
            return false
    }
}

const ListButton = ({editor, type}) => {
    const isActive = isListActive(editor, type)

    const handleClick = useCallback((e) => {
            if (!editor) return;

            switch (type) {
                case "bulletList":
                    editor.chain().focus().toggleBulletList().run()
                    break
                case "orderedList":
                    editor.chain().focus().toggleOrderedList().run()
                    break
            }

            requestAnimationFrame(() => editor.commands.focus());
        },
        [editor, type]
    )

    return (
        <MenuItem>
            <button className={"rich-text-button" + (isActive ? " active" : "")} onClick={handleClick} title={listTitle[type]} onMouseDown={(e) => e.preventDefault()}>
                {icons[type]}
            </button>
        </MenuItem>
    )
}

const RichTextListDropdownMenu = ({types}) => {
    const { editor } = useContext(EditorContext);

    if (!editor || !editor.isEditable) return null

    const activeType = useEditorState({
        editor,
        selector: ({ editor }) => {
            if (!editor) return null;
            return types.find((t) => isListActive(editor, t)) ?? null;
        },
    });

    const ActiveIcon = activeType ? icons[activeType] : <FaListUl className="ich-text-button-icon" />

    return (
        <Menu>
            <MenuButton className="rich-text-button" title="Listas">
                {ActiveIcon}
                <FaChevronDown className="rich-text-button-dropdown-small" />
            </MenuButton>
            <Transition
                enter="transition ease-out duration-75"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="transition ease-in duration-100"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
            >
                <MenuItems anchor="bottom" className="heading-dropdown">
                    {
                        types.map(t => <ListButton editor={editor} type={t} key={t}/>)
                    }
                </MenuItems>
            </Transition>
        </Menu>
    );
};

export default RichTextListDropdownMenu;